























import { Component, Prop, Vue } from "vue-property-decorator";
import SvgIcon from "@/components/ui/SvgIcon.vue";

@Component({
  components: {
    SvgIcon,
  },
})
export default class NavIcon extends Vue {
  @Prop({
    required: true,
  })
  iconPath: string;

  @Prop({
    required: true,
  })
  tooltip: string;

  @Prop({
    default: "",
  })
  classes: string;

  @Prop({
    default: false,
  })
  active: boolean;
}
